var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regular_link",on:{"click":_vm.goToHomepage}},[_c('VcImage',{staticClass:"logo",attrs:{"image":_vm.isBranded ? _vm.branding.logo_path : _vm.branding.new_logo_path}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }